/**
 * @generated SignedSource<<12e87c488630b4e18abba96ae033b490>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRow_fieldSets$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly fieldSetId: string | null | undefined;
      readonly fields: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: string;
            readonly __id: string;
            readonly fieldId: string;
            readonly id?: string;
            readonly type: string;
            readonly " $fragmentSpreads": FragmentRefs<"AffectedServicesCell" | "CascadingSelectCell" | "CheckboxSelectCell" | "CmdbObjectsCell" | "CommentSummaryCell" | "ComponentsCell" | "ComponentsCell_ComponentsInlineEditCell" | "ConfluencePagesCell" | "DateInlineEditCell" | "DateInlineEditCell_DateInlineEditCell" | "DateTimeCell" | "EpicLinkCell" | "FallbackCell" | "FlagCell" | "GoalsCell" | "IssueKeyCell" | "IssueLinksCell" | "IssueStatusCategoryCell" | "IssueStatusCell" | "IssueSummaryCell" | "IssueTypeCell" | "LabelsCell" | "LinkRelationshipTypeCell_fieldRef" | "MultiGroupPickerCell" | "MultiSelectCell" | "MultiUserPickerCell" | "MultiVersionPickerCell" | "NumberCell" | "OriginalEstimateCell" | "ParentCell" | "PlainTextCellOld" | "PlainTextCellOld_PlainTextCellOld" | "PriorityCell" | "ProjectCell" | "RadioSelectCell" | "RequestTypeCell" | "ResolutionCell" | "RichTextCell" | "SingleSelectCell" | "SprintCell" | "TeamCell" | "TimelineCellRenderer" | "UrlCell" | "UserCellInternal" | "VersionsCell" | "WatchersCell">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly totalCount?: number | null | undefined;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useCellsConditionalFormatting">;
  readonly " $fragmentType": "IssueRow_fieldSets";
};
export type IssueRow_fieldSets$key = {
  readonly " $data"?: IssueRow_fieldSets$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow_fieldSets">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "type"
},
v1 = {
  "kind": "Variable",
  "name": "isInlineEditingEnabled",
  "variableName": "isInlineEditingEnabled"
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "kind": "Variable",
    "name": "isEditableSyncLoaded",
    "variableName": "isEditableSyncLoaded"
  },
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isEditableSyncLoaded"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueRow_fieldSets",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useCellsConditionalFormatting"
        }
      ]
    },
    {
      "concreteType": "JiraIssueFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "fieldSetId"
            },
            {
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "totalCount"
                    }
                  ]
                },
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "id"
                            }
                          ]
                        },
                        {
                          "kind": "ScalarField",
                          "name": "__typename"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fieldId"
                        },
                        (v0/*: any*/),
                        {
                          "kind": "FragmentSpread",
                          "name": "AffectedServicesCell"
                        },
                        {
                          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "CascadingSelectCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "ComponentsCell_ComponentsInlineEditCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "DateTimeCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "PlainTextCellOld"
                            },
                            {
                              "kind": "FragmentSpread",
                              "name": "CommentSummaryCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "UrlCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "SingleSelectCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "MultiSelectCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "CheckboxSelectCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "MultiUserPickerCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "TeamCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "OriginalEstimateCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "RadioSelectCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "MultiVersionPickerCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "GoalsCell"
                            },
                            {
                              "args": (v2/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "ConfluencePagesCell"
                            }
                          ]
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "CmdbObjectsCell"
                        },
                        {
                          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                          "kind": "Condition",
                          "passingValue": false,
                          "selections": [
                            {
                              "kind": "FragmentSpread",
                              "name": "ComponentsCell"
                            },
                            {
                              "kind": "FragmentSpread",
                              "name": "PlainTextCellOld_PlainTextCellOld"
                            }
                          ]
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "DateInlineEditCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "DateInlineEditCell_DateInlineEditCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "EpicLinkCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "FallbackCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "IssueKeyCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "IssueStatusCategoryCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "IssueStatusCell"
                        },
                        {
                          "args": (v3/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "IssueSummaryCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "LabelsCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "IssueTypeCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "ParentCell"
                        },
                        {
                          "args": (v3/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "PriorityCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "ProjectCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "ResolutionCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "SprintCell"
                        },
                        {
                          "args": (v3/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "UserCellInternal"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "VersionsCell"
                        },
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "isDensityFull",
                              "variableName": "isDensityFull"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "RichTextCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "RequestTypeCell"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "IssueLinksCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "NumberCell"
                        },
                        {
                          "args": (v2/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "MultiGroupPickerCell"
                        },
                        {
                          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "kind": "FragmentSpread",
                              "name": "FlagCell"
                            }
                          ]
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "WatchersCell"
                        },
                        {
                          "condition": "isLinkRelationshipFieldEnabled",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "args": (v3/*: any*/),
                              "kind": "FragmentSpread",
                              "name": "LinkRelationshipTypeCell_fieldRef"
                            }
                          ]
                        },
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "isTimelineEnabled",
                              "variableName": "isTimelineEnabled"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "TimelineCellRenderer"
                        },
                        {
                          "kind": "ClientExtension",
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "__id"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueFieldSetConnection"
};
})();

(node as any).hash = "587d35e5c922bbdd9e1216eb17751b52";

export default node;
